import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Correct from "../../images/Correct.svg";
import Incorrect from "../../images/Incorrect.svg";
import styles from "./styles";
import "animate.css/animate.css";

const AnswerModal = ({
  classes,
  nextQuestion,
  answeredCorrectly,
  question,
  submitted,
  setShowThirdScreen,
  setSubmitted,
}) => {
  return (
    <Modal open={submitted} onClick={() => setShowThirdScreen(true)}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          <Typography
            className={classes.quesText}
            style={{ fontWeight: "600" }}
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></Typography>
          <Grid container justify="center">
            {answeredCorrectly ? (
              <img
                alt=""
                src={Correct}
                className={classes.correctIncorrectIcon}
              />
            ) : (
              <img
                alt=""
                src={Incorrect}
                className={classes.correctIncorrectIcon}
              />
            )}
          </Grid>
          <Typography
            className={classes.evalDesc}
            dangerouslySetInnerHTML={{ __html: question.description }}
          ></Typography>
          <Grid container justify="center">
            <Button className={classes.submitButton}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(AnswerModal);
